// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-info-date__wrapper{position:relative;cursor:default}.article-info-date__wrapper /deep/ .popup__wrapper{padding:15px 10px}@media (max-width:767px){.article-info-date__wrapper /deep/ .popup__wrapper{padding:16px 8px}}.article-info-date__text{color:#5a585d}.article-info-date__popup-text{font-weight:400}", ""]);
// Exports
module.exports = exports;
